export default "__VITE_ASSET__NfDQ1cK3__"